import { Instance, types, flow } from "mobx-state-tree";
import axios from "axios";
import { PROFILE_API } from "@constants/api";
import { AlertResultApi } from "@utils/alert";
import Swal from "sweetalert2";

export const initialStateProfile = {
  fetching: "done",
};

const BillingAddress = types.model('BillingAddress', {
  blockNumber: types.maybeNull(types.string),
  postalCode: types.maybeNull(types.string),
  building: types.maybeNull(types.string),
  address: types.maybeNull(types.string),
  unit: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
});

const User = types.model('User', {
  id: types.number,
  email: types.string,
  accountingCustomerId: types.number,
});

const ProfileUser = types.model('ProfileUser', {
  id: types.number,
  user: types.maybeNull(User),
  salutation: types.string,
  firstName: types.string,
  lastName: types.string,
  securityCode: types.maybeNull(types.string),
  mobile: types.string,
  vaNumber: types.maybeNull(types.string),
  status: types.string,
  billingAddress: types.optional(BillingAddress, {}),
  billingEmails: types.maybeNull(
      types.array(
          types.model({
            id: types.number,
            email: types.string,
          }),
      ),
  ),
  students: types.maybeNull(types.string),
  createdAt: types.maybeNull(types.string),
  updatedAt: types.maybeNull(types.string),
});

export const Profile = types
  .model({
    profileUser: types.maybeNull(ProfileUser),
    fetching: types.optional(types.string, "done"),
    status: types.maybeNull(types.number),
  })
  .actions((self) => ({
    getProfile: flow(function* getProfile(token: string) {
      self.fetching = "pending";
      self.profileUser = null;
      self.status = null;

      try {
        const result = yield axios.get(`${PROFILE_API}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(result);
        self.fetching = "done";
        self.profileUser = result.data;
      } catch (error) {
        // ... including try/catch error handling
        self.fetching = "error";
        self.status = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
    updateProfile: flow(function* updateProfile(
      token: string,
      profileUser: any,
      callback: () => void
    ) {
      self.fetching = "pending";
      self.status = null;

      try {
        const result = yield axios.put(`${PROFILE_API}`, profileUser, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(result);
        self.fetching = "done";
        self.status = result.status;
        callback();
      } catch (error) {
        // ... including try/catch error handling
        console.log("getClassSchedulePlans", error);
        self.fetching = "error";
        self.status = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
  }));

export type ProfileType = Instance<typeof Profile>;
export type ProfileUserType = Instance<typeof ProfileUser>;
